import axios from 'axios';
import { API_URL } from '../utils/apiConfig';

// Get all notifications
export const getNotifications = async (page = 1, limit = 20, options = {}) => {
  try {
    const token = localStorage.getItem('token');
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    });
    if (options.type) params.set('type', options.type);
    if (options.pipelineOnly) params.set('pipelineOnly', 'true');

    const response = await axios.get(`${API_URL}/notifications?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to load notifications' };
  }
};

// Get unread notifications count
export const getUnreadCount = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/notifications/unread-count`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to load unread count' };
  }
};

// Mark notification as read
export const markAsRead = async (notificationId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/notifications/${notificationId}/read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to mark notification as read' };
  }
};

// Mark all notifications as read
export const markAllAsRead = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/notifications/mark-all-read`, {}, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to mark all notifications as read' };
  }
};

// Delete notification
export const deleteNotification = async (notificationId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${API_URL}/notifications/${notificationId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to delete notification' };
  }
};

// Move patient pipeline reminder to next stage
export const movePipelineToNextStage = async (patientId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${API_URL}/patients/${patientId}/pipeline-stage`, { stage: 'treatment_started' }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Failed to move patient to next stage' };
  }
};
